import { useState } from 'react';
import { attributesToProps } from 'html-react-parser';
import { validateConsultation } from '../lib/formValidation';
import { useRequestSubmission } from '../hooks/useRequestSubmission';
import { ConsultationFields, ConsultationSuccess } from './ConsultationFields';

export const ConsultationForm = ({ node, sourcePath }) => {
  const [errors, setErrors] = useState({});
  const { busy, error, receipt, clearError, submit: send, reset } = useRequestSubmission('/consultations');
  const props = attributesToProps(node.attribs);
  const testId = props['data-testid'];
  const submit = async event => {
    event.preventDefault();
    const form = event.currentTarget;
    const data = Object.fromEntries(new FormData(form));
    const invalid = validateConsultation(data);
    setErrors(invalid); clearError();
    const firstInvalid = Object.keys(invalid)[0];
    if (firstInvalid) { form.elements[firstInvalid]?.focus(); return; }
    await send({ ...data, sourcePath });
  };
  return <form {...props} onSubmit={submit} noValidate>
    {receipt ? <ConsultationSuccess receipt={receipt} testId={testId} onReset={reset} /> : <ConsultationFields node={node} busy={busy} errors={errors} setErrors={setErrors} />}
    {error && <p role="alert" className="consultation-error" data-testid={`${testId}-error`}>{error}</p>}
  </form>;
};